import { Link } from 'react-router-dom';
import { Page } from '@/components/Page';
import { Section } from '@/components/Section';

export function BetaIndexPage(): JSX.Element {
  return (
    <Page title="Beta 🤖">
      <Section header="Торговые боты" footer="Выберите раздел для управления ботом.">
        <Link
          to="/beta/shp1"
          style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: 'var(--space-md) var(--space-lg)', textDecoration: 'none', color: 'var(--tg-text)', borderBottom: '0.5px solid var(--tg-separator)' }}
        >
          <div>
            <div style={{ fontWeight: 600 }}>SHP-1</div>
            <div style={{ fontSize: 12, color: 'var(--tg-hint)', marginTop: 2 }}>Торговый бот (FxPro · Vantage · Weex)</div>
          </div>
          <span style={{ color: 'var(--tg-hint)' }}>›</span>
        </Link>
        <Link
          to="/beta/arbt1"
          style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: 'var(--space-md) var(--space-lg)', textDecoration: 'none', color: 'var(--tg-text)' }}
        >
          <div>
            <div style={{ fontWeight: 600 }}>ARBT-1</div>
            <div style={{ fontSize: 12, color: 'var(--tg-hint)', marginTop: 2 }}>Арбитражный бот (13 бирж)</div>
          </div>
          <span style={{ color: 'var(--tg-hint)' }}>›</span>
        </Link>
      </Section>
    </Page>
  );
}
